import { ArticlesOfIncorporationForm } from "@/components/articles-of-incorporation/ArticlesOfIncorporationForm"
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

type ApplicationsDialogProps = {
  dialogOpen: boolean
  companyUuid: string
  onNext: () => void
}

export function ApplicationsDialog({
  dialogOpen,
  companyUuid,
  onNext,
}: ApplicationsDialogProps) {
  return (
    <AlertDialog open={dialogOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Additional steps required</AlertDialogTitle>
          <AlertDialogDescription>
            Please upload your business incorporation document before submitting
            the application.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <ArticlesOfIncorporationForm
          companyUuid={companyUuid}
          onNext={onNext}
        />
      </AlertDialogContent>
    </AlertDialog>
  )
}
